import React from 'react';
import { AppBar as MuiAppBar, Toolbar } from '@mui/material';
import UserProfile from '../UserProfile/UserProfile';

/**
 * Global AppBar Component
 *
 * Provides a consistent top bar across all authenticated pages
 * Contains the UserProfile component in the top right
 */
const AppBar = () => {
  return (
    <MuiAppBar
      position="static"
      elevation={0}
      sx={{
        backgroundColor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
        zIndex: theme => theme.zIndex.drawer + 1,
      }}
    >
      <Toolbar
        sx={{
          justifyContent: 'flex-end',
          minHeight: '48px !important',
          px: 2,
        }}
      >
        <UserProfile />
      </Toolbar>
    </MuiAppBar>
  );
};

export default AppBar;
